<script lang="ts">
    import { onMount } from 'svelte';
    import { PUBLIC_GTM_ID } from '$env/static/public';
    import { pageview } from '$src/lib/services/gtm';

    const loadGTM = () => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ 'gtm.start': new Date().getTime().toString(), event: 'gtm.js' });
        const f = document.getElementsByTagName('script')[0];
        const j = document.createElement('script');
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + PUBLIC_GTM_ID;
        f.parentNode?.insertBefore(j, f);
    };

    onMount(() => {
        loadGTM();
        pageview();
    });
</script>
